import router from './router';
import store from './store';
import { getToken, setToken } from '@/utils/auth'; // get token from cookie
/* eslint-disable */

router.beforeEach(async (to, from, next) => {
  // determine whether the user has logged in
  if (window.location.href.indexOf('token') > -1) {
    setToken (window.location.href.split('token=')[1]);
  }
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' });
    } else {
      await store.dispatch('permission/generateRoutes', []);
      await store.dispatch('app/getAppName');
      await store.dispatch('app/getContract');
      await store.dispatch('user/getUserRoles');
      next();
    }
  } else {
    if (to.path === '/login' || to.path === '/do' || to.path === '/encrypt' || to.path === '/application' || to.path === '/register' || to.path === '/go') {
      next();
    } else {
      next({ path: '/login' });
    }
  }
});



// WEBPACK FOOTER //
// ./src/permission.js